import { create } from 'zustand';
import type { EntityType, MigrationJobStatus } from '../types/migration.types';

export interface Notification {
  id: string;
  title: string;
  body: string;
  type: 'info' | 'success' | 'warning' | 'error';
  is_read: boolean;
  link?: string;
  created_at: string;
}

export interface ActiveImportJob {
  jobId: string;
  entityType: EntityType;
  status: MigrationJobStatus;
  imported_count: number;
  total_records: number;
}

interface NotificationState {
  notifications: Notification[];
  unread_count: number;
  isDrawerOpen: boolean;
  activeImportJob: ActiveImportJob | null;

  setNotifications: (notifications: Notification[]) => void;
  addNotification: (notification: Notification) => void;
  markAllRead: () => void;
  setDrawerOpen: (open: boolean) => void;
  setActiveImportJob: (job: ActiveImportJob) => void;
  clearActiveImportJob: () => void;
}

export const useNotificationStore = create<NotificationState>()((set, get) => ({
  notifications: [],
  unread_count: 0,
  isDrawerOpen: false,
  activeImportJob: null,

  setNotifications: (notifications) =>
    set({
      notifications,
      unread_count: notifications.filter((n) => !n.is_read).length,
    }),

  addNotification: (notification) => {
    const notifications = [notification, ...get().notifications];
    set({
      notifications,
      unread_count: notifications.filter((n) => !n.is_read).length,
    });
  },

  markAllRead: () =>
    set((state) => ({
      notifications: state.notifications.map((n) => ({ ...n, is_read: true })),
      unread_count: 0,
    })),

  setDrawerOpen: (open) => set({ isDrawerOpen: open }),

  setActiveImportJob: (job) => set({ activeImportJob: job }),

  clearActiveImportJob: () => set({ activeImportJob: null }),
}));
